import React from 'react';

import { Dropzone } from '@/components/Dropzone';

interface DocumentUploadZoneProps {
  onFilesDrop: (files: { content: string | ArrayBuffer; file: File }[]) => void;
  uploadProgress: number | null;
  title?: string;
  subTitle?: string;
}

export const DocumentUploadZone: React.FC<DocumentUploadZoneProps> = ({
  onFilesDrop,
  uploadProgress,
  title = 'Click or drag and drop files here',
  subTitle,
}) => {
  if (uploadProgress !== null) {
    return (
      <div className="w-full">
        <div className="relative pt-1">
          <div className="mb-2 flex items-center justify-between">
            <span className="text-chariot-text-primary text-xs font-semibold uppercase">
              Uploading...
            </span>
            <span className="text-brand text-xs font-semibold">
              {Math.round(uploadProgress)}%
            </span>
          </div>
          <div className="bg-chariot-background-tertiary h-2 overflow-hidden rounded">
            <div
              style={{ width: `${uploadProgress}%` }}
              className="bg-brand h-full transition-all duration-300"
            ></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <Dropzone
      type="arrayBuffer"
      onFilesDrop={onFilesDrop}
      title={title}
      subTitle={subTitle}
    />
  );
};
